import { render, staticRenderFns } from "./CustomerDetailsInfo.vue?vue&type=template&id=194272a8&scoped=true"
import script from "./CustomerDetailsInfo.vue?vue&type=script&lang=js"
export * from "./CustomerDetailsInfo.vue?vue&type=script&lang=js"
import style0 from "./CustomerDetailsInfo.vue?vue&type=style&index=0&id=194272a8&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "194272a8",
  null
  
)

export default component.exports